/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Commons_Links_Legal_LinksInputs */

const de_commons_links_legal_links = /** @type {(inputs: Commons_Links_Legal_LinksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechtliche Links`)
};

/** @type {(inputs: Commons_Links_Legal_LinksInputs) => LocalizedString} */
const en_commons_links_legal_links = de_commons_links_legal_links;

/**

* @param {Commons_Links_Legal_LinksInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const commons_links_legal_links = /** @type {((inputs?: Commons_Links_Legal_LinksInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Commons_Links_Legal_LinksInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_commons_links_legal_links(inputs)
	return en_commons_links_legal_links(inputs)
});